export enum ConnectFile3dStatus {
  CheckingStatus = 'CheckingStatus',
  RegionNotSupported = 'RegionNotSupported',
  IngestionError = 'IngestionError',
  QuotaWillBeExceeded = 'QuotaWillBeExceeded',
  QuotaExceeded = 'QuotaExceeded',
  ReadyToRefresh = 'ReadyToRefresh',
  Tiling = 'Tiling',
  TilingError = 'TilingError',
  Loading = 'Loading',
  Loaded = 'Loaded',
  LoadingFailed = 'LoadingFailed',
  InsufficientPermission = 'InsufficientPermission',
  NoActiveLicense = 'NoActiveLicense',
  Unloading = 'Unloading',
  Unloaded = 'Unloaded',
}
